// extracted by mini-css-extract-plugin
export default {"inputRow":"InputArea_inputRow__1lZ7J","recipientSelect":"InputArea_recipientSelect__IJ2Qm","alert":"InputArea_alert__DpTkG"};